import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {FilePreviewDialogComponent} from './file-preview-dialog.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SpinnerModule} from '../../components/spinner/spinner.module';


@NgModule({
  declarations: [
    FilePreviewDialogComponent
  ],
    imports: [
        SharedModule,
        MatButtonModule,
        MatIconModule,
        PdfViewerModule,
        MatProgressSpinnerModule,
        SpinnerModule
    ]
})
export class FilePreviewModule { }
